import { c as _c } from "react/compiler-runtime";
import type { PaymentMethods } from 'api-graphql-types';
import analytics, { getDonationFormType } from 'product-analytics';
import { useEffect, useEffectEvent, useRef, useState } from 'react';
import { useDonationFormConfig } from '@/donationPages/_dependencies/DonationFormConfigContext';
import { useDonationFormValues } from '@/donationPages/_dependencies/helpers';
function useTrackPaymentMethodChange() {
  const $ = _c(16);
  const {
    receiverId,
    receiverType,
    channel,
    showCodonation
  } = useDonationFormConfig();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["payment_method", "_default_payment_method"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [paymentMethod, defaultPaymentMethod] = useDonationFormValues(t0);
  const previousPaymentMethod = useRef(paymentMethod);
  const [initialChange, setInitialChange] = useState(true);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const timeout = setTimeout(() => setInitialChange(false), 0);
      return () => clearTimeout(timeout);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== defaultPaymentMethod) {
    t2 = [defaultPaymentMethod];
    $[2] = defaultPaymentMethod;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== channel || $[5] !== defaultPaymentMethod || $[6] !== initialChange || $[7] !== receiverId || $[8] !== receiverType || $[9] !== showCodonation) {
    t3 = method => {
      if (initialChange && method === defaultPaymentMethod) {
        return;
      }
      if (method !== defaultPaymentMethod) {
        setInitialChange(false);
      }
      analytics.paymentMethodChanged({
        id: receiverId,
        receiver_type: receiverType,
        donation_form_type: getDonationFormType({
          receiverId,
          receiverType,
          channel,
          showCodonation
        }),
        previous_payment_method: previousPaymentMethod.current,
        new_payment_method: method
      });
    };
    $[4] = channel;
    $[5] = defaultPaymentMethod;
    $[6] = initialChange;
    $[7] = receiverId;
    $[8] = receiverType;
    $[9] = showCodonation;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handlePaymentMethodChanged = useEffectEvent(t3);
  let t4;
  if ($[11] !== handlePaymentMethodChanged || $[12] !== paymentMethod) {
    t4 = () => {
      handlePaymentMethodChanged(paymentMethod);
      previousPaymentMethod.current = paymentMethod;
    };
    $[11] = handlePaymentMethodChanged;
    $[12] = paymentMethod;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== paymentMethod) {
    t5 = [paymentMethod];
    $[14] = paymentMethod;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  useEffect(t4, t5);
}
export default useTrackPaymentMethodChange;